var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventMapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0016 25.2001L10.8016 22.6801L5.22156 24.8401C4.82156 25.0001 4.45156 24.9551 4.11156 24.7051C3.77156 24.4551 3.60156 24.1201 3.60156 23.7001V6.9001C3.60156 6.6401 3.67656 6.4101 3.82656 6.2101C3.97656 6.0101 4.18156 5.8601 4.44156 5.7601L10.8016 3.6001L18.0016 6.1201L23.5816 3.9601C23.9816 3.8001 24.3516 3.8451 24.6916 4.0951C25.0316 4.3451 25.2016 4.6801 25.2016 5.1001V21.9001C25.2016 22.1601 25.1266 22.3901 24.9766 22.5901C24.8266 22.7901 24.6216 22.9401 24.3616 23.0401L18.0016 25.2001ZM16.8016 22.2601V8.2201L12.0016 6.5401V20.5801L16.8016 22.2601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventMapsIcon);
export default __webpack_public_path__ + "static/media/EventMapsIcon.0956a7601934b8c42af086669542c9a8.svg";
export { ForwardRef as ReactComponent };